import React from "react";

const TOC = ({
  openTOC,
  openNP,
  isActive,
  isVisible = false,
  showAcceptButton = false,
  onAccept = null,
}) => {
  return (
    <section className="toc" aria-hidden={isVisible}>
      <div className="toc-wrapper">
        <button className="toc-close" onClick={() => openTOC()}>
          close modal
        </button>
        <h2>Burger King® Keep it Real Meals NFT Promotion Official Rules</h2>
        <div className="toc-content">
          <h3>
            NO PURCHASE NECESSARY. A PURCHASE WILL NOT INCREASE YOUR CHANCES OF
            WINNING.
          </h3>
          <p>
            <strong>1. Eligibility:</strong> The Burger King® Keep it Real Meals
            NFT Promotion (“Promotion”) includes three (3) independent “Instant
            Win” Games (each a “Game”). Each Game is associated with one of the
            three “Artists”: Cornell Iral Haynes Jr. (“Nelly”), Larissa de
            Macedo Machado (“Anitta”), Cole Chase Hudson (“Lil Huddy”) who have
            collaborated with Sponsor to create a special Burger King® Keep It
            Real Meal (a “Real Meal”).
          </p>
          <p>
            The Promotion is open only to legal residents of the fifty (50)
            United States and the District of Columbia who are at least eighteen
            (18) years old at the time of entry. Employees, non-employee
            workers, officers, and representatives of Burger King Corporation
            (“Sponsor”), SocialSweet Inc. (“Administrator”), Merkle Inc., and
            Artists, as well as the immediate family (spouse, parents, siblings,
            and children) and household members of each such employee are not
            eligible. The Promotion is subject to all applicable federal, state,
            and local laws and regulations and is void where prohibited.
            Participation in the Promotion constitutes entrant’s full and
            unconditional agreement to these Official Rules. Sponsor’s and
            Administrator's decisions are final and binding in all matters
            related to the Promotion. Winning a prize is contingent upon
            fulfilling all requirements set forth herein.
          </p>
          <p>
            <strong>2. Sponsor:</strong> Burger King Corporation, 5707 Blue
            Lagoon Drive, Miami, FL 33126.
            <br />
            <strong>Administrator:</strong> SocialSweet Inc. DBA Sweet,
            SocialSweet, Inc. (DBA Sweet), 30 W Park Place Morristown, New
            Jersey 07960.
          </p>
          <p>
            <strong>3. Timing:</strong> The Promotion begins on September 16,
            2021 at 12:00 noon Eastern Time ("ET") and end on October 10, 2021
            at 11:59 p.m. ET, or when all Game Pieces (defined below) have been
            distributed, whichever occurs sooner (the "Promotion Period").
            Administrator’s servers for its web and mobile platform will be the
            official time-keeping devices for the Promotion.
          </p>
          <p>
            <strong>4. How to Enter & Play:</strong> All entrants will be
            required to create a Sweet.io account (“Account”). Entrants can
            create their Account using the Sweet Mobile App or the Sweet.io web
            platform. (“Sweet Platform”). Accounts are free, but subject to the{" "}
            <a
              href="https://about.sweet.io/legal/terms/"
              target="_blank"
              rel="noreferrer">
              Sweet Terms of Use
            </a>
            . You will need to provide your name and email address (or mobile
            phone number) when creating an Account. The Sweet Platform is a
            marketplace for purchase, storing and trading Non Fungible Tokens
            (”NFTs”). In each Game, you will have the opportunity to collect up
            to nine (9) different NFTs (the “Game Pieces”), from the Artist
            associated with that Game (a total of 27 NFT Games Pieces are
            available across the three (3) Artists) and you will store these
            Game Pieces within your Account. Each Game Piece is promotional in
            nature and has no retail value. During the Promotion Period, Game
            Pieces may not be traded outside of the Sweet Platform.
          </p>
          <div data-spacing="left">
            <div>
              <h4>
                <u>To Enter:</u>
              </h4>
              <p>
                <strong>
                  With Purchase of a “Real Meal” and Real Meal Box QR Code:
                </strong>{" "}
                During the Promotion Period, purchase a Real Meal from a
                participating Burger King restaurant. Then use your mobile
                device to scan the QR code on the box of a Real Meal from the
                Artist of your choice (available while supplies last). The QR
                Code will open up on the Promotional Site where you will be
                prompted to follow the links and instructions to agree to these
                Official Rules.
              </p>
              <p>
                <strong>
                  To Enter without Purchase or Real Meal Box QR Code:
                </strong>{" "}
                During the Promotion Period, to enter without the purchase of a
                Real Meal or scanning a QR Code (the “Alternate Method of Entry”
                or “AMOE”), go to realmeals.sweet.io, locate the Official Rules
                and navigate to this section 4. (“To Enter without Purchase or
                Real Meal Box QR Code”). Then{" "}
                {isActive && <a onClick={() => openNP()}>CLICK HERE</a>} and
                follow the links and instructions to select your Artist from the
                three Artists. You will then be prompted to follow the links and
                instructions to agree to these Official Rules.
              </p>
              <br />
            </div>
            <h4>
              <u>To Play:</u>
            </h4>
            <div>
              <p>
                <strong>Collect Game Pieces:</strong>
                After you accept the Official Rules on the Promotion Site you
                will be instructed to set up your Account on the Sweet Platform.
                Once your Account is set up, you will be awarded, at random, a
                Game Piece associated with the Artist you selected. You may
                collect Game Pieces for all three Artists. However, you can only
                collect a new Game Piece for each Artist once every twelve (12)
                hours by rescanning the QR code on the Real Meals box or via the
                AMOE. <strong>Limit:</strong> One (1) Game Piece per Artist per
                twelve (12) hour period, regardless of method (i.e., scan,
                rescan or AMOE ). The odds of receiving a particular Game Piece
                are set forth in the chart below.
              </p>
              <br />
            </div>
            <p>
              <strong>Game Piece Descriptions:</strong> For each Artist, there
              are three (3) different Game Pieces: Flippable, Real Signature and
              Behind the Scenes. Each Game Piece will also have one of three (3)
              suit icons “Suits” stamped in the corner of Game Piece: Fries,
              Shake and Burger (each a “Suit”), for a total of nine (9) unique
              Game Pieces for each Artist. The odds of receiving each Game Piece
              are as set forth in the chart below:
            </p>
            <table>
              <tbody>
                <tr>
                  <td>
                    Flippable + Shake
                    <br />
                    Odds: 2:10
                  </td>
                  <td>
                    Real Signature + Shake
                    <br />
                    Odds: 1: 10
                  </td>
                  <td>
                    Behind the Scenes + Shake
                    <br />
                    Odds: 3:100
                  </td>
                </tr>
                <tr>
                  <td>
                    Flippable + Fries
                    <br />
                    Odds: 2:10
                  </td>
                  <td>
                    Real Signature + Fries
                    <br />
                    Odds: 1: 10
                  </td>
                  <td>
                    Behind the Scenes + Fries
                    <br />
                    Odds: 3:100
                  </td>
                </tr>
                <tr>
                  <td>
                    Flippable + Burger
                    <br />
                    Odds: 2: 10
                  </td>
                  <td>
                    Real Signature + Burger
                    <br />
                    Odds: 1: 10
                  </td>
                  <td>
                    Behind the Scenes + Burger
                    <br />
                    Odds: 3:100
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              The goal is to collect an Artist’s “Set”, which consists of the
              three (3) different Game Pieces for that Artist, all stamped with
              the same “Suit.” For example: Flippable + Fries, Real Signature +
              Fries and Behind the Scenes + Fries, is a Set; whereas Flippable +
              Fries, Real Signature + Fries and Behind the Scenes + Shake is NOT
              a Set.
            </p>
            <p>
              <strong>Collect A Set:</strong> Once an entrant collects a Set for
              an Artist, entrant will be awarded a special 3D Burger King NFT or
              an NFT awarding one of the other limited Prizes offered for the
              applicable Artist listed below in Section 7. Once your Set is
              complete, the Game Pieces in the Set are “locked” in your Sweet
              Account and cannot be moved, gifted, reused, transferred or traded
              during the Promotion Period. The approximate odds of winning one
              of these limited Prizes are listed below in the Section 7.
            </p>{" "}
            <p>
              <strong>Trading Game Pieces:</strong> Within the Sweet Platform,
              you will be able to trade a Game Piece you hold in your Sweet
              Account, as long as the Game Piece has not been used to a complete
              a Set. Just follow the instructions and prompts on the Platform.
              There is no limit on the number of Game Pieces you may retain in
              your Account. During the Promotion Game pieces cannot be removed
              from the Sweet Platform.
            </p>
          </div>
          <p>
            <u>Limit:</u> Each entrant may receive up to two (2) Game Pieces
            each day (one (1) every 12 hours) per Artist (six (6) Game Pieces
            each day in total if collecting for the three (3) Artists) during
            the Promotion Period, while Game Pieces are available. Multiple
            entrants are not permitted to share the same email address/mobile
            phone number. Any attempt by any entrant to obtain more than the
            stated number of plays by using multiple/different email addresses,
            mobile phone numbers, identities, registrations and logins, or any
            other methods will void that entrant's plays and that entrant may be
            disqualified. Use of any automated system to participate is
            prohibited and will result in disqualification. Sponsor is not
            responsible for lost, late, incomplete, invalid, unintelligible, or
            misdirected registrations, which will be disqualified. In the event
            of a dispute as to any registration or play, the authorized account
            holder of the email address or mobile phone number used to register
            will be deemed to be the entrant or player. The “authorized account
            holder” is the natural person assigned an email address by an
            Internet access provider, online service provider, Internet service
            provider, or other organization responsible for assigning email
            addresses for the domain associated with the submitted address. Each
            potential winner may be required to show proof of being the
            authorized account holder.
          </p>
          <p>
            <strong>
              5. ALL POTENTIAL WINNING PLAYS (COLLECTION OF A SET) ARE SUBJECT
              TO VERIFICATION BY SPONSOR OR ADMINISTRATOR, WHOSE DECISIONS ARE
              FINAL AND BINDING. AN ENTRANT IS NOT A WINNER OF ANY PRIZE, EVEN
              IF THE GAME SHOULD SO INDICATE, UNLESS AND UNTIL ENTRANT’S
              ELIGIBILITY AND THE POTENTIAL WINNING PLAY HAVE BEEN VERIFIED AND
              ENTRANT HAS BEEN NOTIFIED THAT VERIFICATION IS COMPLETE. SPONSOR
              WILL NOT ACCEPT SCREEN SHOTS OR OTHER EVIDENCE OF WINNING IN LIEU
              OF ITS VALIDATION PROCESS. ANY PLAY THAT OCCURS AFTER THE SYSTEM
              HAS FAILED FOR ANY REASON IS DEEMED A DEFECTIVE PLAY, IS VOID, AND
              WILL NOT BE HONORED.
            </strong>
          </p>{" "}
          <p>
            <strong>6. Winner Requirements and Communications:</strong>{" "}
            Receiving a prize is contingent upon compliance with these Official
            Rules. Administrator is an independent judging organization whose
            decisions as to the administration and operation of the Game are
            final and binding. When an entrant is awarded one of the prizes set
            forth in Section 7 below, potential winner will receive a
            confirmation email with instruction on how to claim the prize. Each
            potential winner of any prize will be required to provide First
            name, Last name, and email address, as well as phone number (for any
            potential Grand Prize winner), and home mailing address (for any
            potential First Prize winner). If any potential winner cannot be
            contacted or if prize is returned as undeliverable, potential winner
            forfeits prize. In the event that a potential winner of any prize is
            disqualified for any reason, Sponsor will award the applicable prize
            to an alternate winner by random drawing from among all eligible
            entrants who completed a Set. There will be three (3) alternate
            drawings after which the applicable prize will remain un-awarded.
          </p>
          <p>
            <strong>7. Prizes:</strong>
          </p>
          <p>
            <strong>NELLY GAME PRIZES:</strong>
            <br /> <u>FIVE (5) GRAND PRIZES:</u> Real Meals Special Kit
            including a mini-speaker, lunch tupper, tote bag and Burger King
            hoodie, autographed by Nelly. Approximate Odds of winning this
            prize: 1: 14,771. ARV: $350.
            <br />
            <u>TWENTY (20) FIRST PRIZES:</u>
            Whopper® Sandwiches for a Year, based upon an average retail price
            of $5.19 per sandwich, calculated as one Whopper® Sandwich per week
            for 52 weeks and fulfilled as a $270 Burger King gift card. Prize
            will be mailed to address provided by winner approximately 2-4 weeks
            after the end of the Promotion. Terms and conditions of gift card
            apply. Approximate Odds of winning this prize: 1: 4,800. ARV: $270.
          </p>
          <p>
            <strong>HUDDY GAME PRIZES:</strong>
            <br /> <u>FIVE (5) GRAND PRIZES:</u> A phone or video call of up to
            5 minutes in duration with Huddy. The time and date of the call will
            be arranged based on Huddy’s availability (winner will be provided
            with 3 options) and must take place no later than December 10, 2021.
            Winner must be located in the United States at the time of the call.
            Artist reserves the right in its sole discretion to end the call for
            any reason, including but not limited to violation of Artist’s
            personal or privacy rights, or any aggressive, insulting or
            disrespectful behavior by winner. Approximate Odds of winning this
            prize: 1: 14,771. ARV: $400
            <br />
            <u>TWENTY (20) FIRST PRIZES:</u> Ch’King™ Sandwiches for a Year,
            based upon an average retail price of $4.75 per sandwich, calculated
            as one Ch’King™ Sandwich per week for 52 weeks and fulfilled as a
            $250 Burger King gift card. Prize will be mailed to address provided
            by winner approximately 2-4 weeks after the end of the Promotion.
            Terms and conditions of gift card apply. Approximate Odds of winning
            this prize: 1: 3,693. ARV: $250
          </p>{" "}
          <p>
            <strong>ANITTA GAME PRIZES:</strong>
            <br />
            <u>FIVE (5) GRAND PRIZES:</u> An NFT with exclusive video content
            from the filming for the TV commercial produced to advertise this
            Game. This prize has no retail value. Approximate Odds of winning
            this prize: 1: 7,384.
            <br />
            <u>TWENTY (20) FIRST PRIZES:</u> Impossible™ Whopper® Sandwiches for
            a Year, based upon an average retail price of $6.19 per sandwich,
            calculated as one Impossible™Whopper® Sandwich per week for 52 weeks
            and fulfilled as a $325.00 Burger King gift card. Prize will be
            mailed to address provided by winner approximately 2-4 weeks after
            the end of the Promotion. Winner must be located in the United
            States at the time of the call. Terms and conditions of gift card
            apply. Approximate Odds of winning this prize: 1: 1,846. ARV:
            $325.00.
          </p>{" "}
          <p>
            No cash or other substitution, assignment or transfer of any prizes
            permitted, except by Sponsor, who reserves the right to substitute a
            prize or prize component with cash or another prize of comparable or
            greater value. Winners are responsible for all federal, state, and
            local taxes and fees associated with prize receipt and/or use.
            Prizes will be awarded "as is" with no warranty or guarantee, either
            express or implied offered by Sponsor. Sponsor is not responsible
            for any Artist Grand Prize that is terminated early by Artist. Gift
            Card prizes will be fulfilled approximately 2-4 weeks after the
            conclusion of the Promotion. Gift Card terms and conditions are
            available at{" "}
            <a
              href="http://www.bk.com/crowncard-terms"
              target="_blank"
              rel="noreferrer">
              www.bk.com/crowncard-terms
            </a>
            . TOTAL ARV OF ALL PRIZES: $20,650.
            <u>Limit:</u> One (1) Grand Prize <strong>or</strong> First Prize
            per person.
          </p>
          <p>
            <strong>8. Publicity:</strong> Except where prohibited,
            participation in the Game constitutes winner's consent to Sponsor's
            use of winner's name, likeness, photograph, voice, opinions,
            biographical information, hometown, and state for promotional
            purposes in any media without further payment or consideration.
          </p>{" "}
          <p>
            <strong>9. General Conditions:</strong> Sponsor reserves the right
            to cancel or modify the Game if fraud, technical failures, human
            error or any other factor impairs the integrity of the Game, as
            determined by Sponsor in its sole discretion. In such event, Sponsor
            reserves the right to award the prizes at random from among the
            eligible entries received up to the time of the impairment. Sponsor
            reserves the right, in its sole discretion, to disqualify any
            individual it finds to be tampering with the entry process or the
            operation of the Game, or to be acting in violation of the Official
            Rules of this or any other promotion, or in an unsportsmanlike or
            disruptive manner. Any attempt by any person to deliberately damage
            any website or undermine the legitimate operation of the Game is a
            violation of criminal and civil law, and, should such an attempt be
            made, Sponsor reserves the right to seek damages from any such
            person to the fullest extent permitted by law. Sponsor's failure to
            enforce any term of these Official Rules shall not constitute a
            waiver of that provision.
          </p>
          <p>
            <strong>
              10. Release: By receipt of any prize, winner agrees to release and
              hold harmless Sponsor, Administrator, Artists, Merkle Inc., and
              any promotional partners, each of their parent, subsidiary,
              affiliate, and related companies, and each of its and their
              respective officers, directors, employees, and agents
              (collectively the “Released Parties”) from and against any losses,
              damages, rights, claim, or cause of action of any kind arising, in
              whole or in part, directly or indirectly, out of participation in
              the Game or resulting directly or indirectly, from acceptance,
              possession, use, or misuse of any prize awarded in connection with
              the Game, including without limitation personal injury, death,
              and/or property damage, as well as claims based on publicity
              rights, defamation, and/or invasion of privacy.
            </strong>
          </p>{" "}
          <p>
            <strong>11. Limitations of Liability:</strong> The Released Parties
            are not responsible for: (1) any incorrect or inaccurate
            information, whether caused by entrants, printing errors or by any
            of the equipment or programming associated with or utilized in the
            Game; (2) technical failures of any kind, including, but not limited
            to malfunctions, interruptions, or disconnections in phone lines, or
            network hardware, or software; (3) unauthorized human intervention
            in any part of the entry process or the Game; (4) technical or human
            error which may occur in the administration of the Game or the
            processing of entries; (5) lost, late, misdelivered or misdirected
            prize awards; or (6) any injury or damage to persons or property
            which may be caused, directly or indirectly, in whole or in part,
            from entrant’s participation in the Game, or receipt, or use of any
            prize or while traveling to or from any prize-related activity. If
            for any reason an entrant's entry is confirmed to have been
            erroneously deleted, lost, or otherwise destroyed or corrupted,
            entrant’s sole remedy is another entry in the Game, if it is
            possible. No more than the stated number of prizes will be awarded.
            In the event that production, technical, seeding, programming, or
            any other reasons cause more than the stated number of prizes as set
            forth in these Official Rules to be available and/or claimed,
            Sponsor reserves the right to award only the stated number of prizes
            by a random drawing among all legitimate, un-awarded, eligible prize
            claims.
          </p>{" "}
          <p>
            <strong>12. Disputes:</strong>
            Entrant agrees that (i) any and all disputes, claims, and causes of
            action arising out of or connected with this Game or any prizes
            awarded shall be resolved individually, without resort to any form
            of class action, and exclusively by the United States District Court
            for the Southern District of Florida or the appropriate Florida
            State Court located in Miami-Dade County, Florida; (ii) any and all
            claims, judgments, and awards shall be limited to actual
            out-of-pocket costs incurred, including costs associated with
            entering this Game but in no event attorneys' fees; and (iii) under
            no circumstances will entrant be permitted to obtain awards for and
            entrant hereby waives all rights to claim punitive, incidental, and
            consequential damages and any other damages, other than for actual
            out-of-pocket expenses, and any and all rights to have damages
            multiplied or otherwise increased. SOME JURISDICTIONS DO NOT ALLOW
            THE LIMITATIONS OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR
            CONSEQUENTIAL DAMAGES, SO THE ABOVE MAY NOT APPLY TO YOU. All issues
            and questions concerning the construction, validity, interpretation,
            and enforceability of these Official Rules, or the rights and
            obligations of the entrant and Sponsor in connection with the Game,
            shall be governed by, and construed in accordance with, the laws of
            the State of Florida, without giving effect to any choice of law or
            conflict of law rules (whether of the State of Florida or any other
            jurisdiction), which would cause the application of the laws of any
            jurisdiction other than the State of Florida.
          </p>{" "}
          <p>
            <strong>13. Entrant's Personal Information:</strong> Information
            collected from entrants is subject to Administrator’s Privacy
            Policy:
            <a
              href="https://about.sweet.io/legal/privacy/"
              target="_blank"
              rel="noreferrer">
              https://about.sweet.io/legal/privacy/
            </a>
            .
          </p>{" "}
          <p>
            <strong>14. Winner List:</strong> For a list of Prize winners,
            please send request to bkrealmealswinners@sweet.io.
          </p>
          <p>© 2021 Merkle Inc. All rights reserved.</p>
        </div>
        {showAcceptButton && (
          <button onClick={() => onAccept()} className="button claim__button">
            Accept rules and claim!
          </button>
        )}
      </div>
    </section>
  );
};

export default TOC;
